<template lang="pug">
.t-content
  template(v-if="startRender")
    #preloader
      #loader
  template(v-else)
    section.info-sec(v-if="newsDetails.length> 0")
      .max-container
        .news-list-wrap
          .news-listbox
            .iimg
              img(:src="imgUrl+newsDetails[0].en_image_url")
              router-link.btn-submit(v-if="!isLoggedIn" to="/register") Sign Up Now
            .ccon(v-html="newsDetails[0].en_full_body")
    errorPage(v-if="newsDetails.length === 0")
</template>
<script>
import config from "@/config";
import errorPage from '@/views/default/_errorPage.vue'
export default{
  components:{
    errorPage
  },
  data(){
    return{
      feedback:{
        success: true,
        status:""
      },
      loading: false,
      imgUrl: config.imageUrl,
      newsDetails:[],
      metaData: [],
      startRender: true
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed:{
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
	},
  created(){
    var temp = window.location.pathname.split("/")
    var target = temp[temp.length-1]
    this.getNewsDetails(target)
  },
  mounted(){
    // this.getSeo()
    window.scroll(0,0)
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    getNewsDetails(target){
      var slug = target
      this.$store
        .dispatch("user/getNewsDetails",{slug})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            if(response.data.length > 0){
              this.newsDetails = response.data
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
          this.startRender = false
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
          this.loading = true
          this.startRender = false
        });
    }
  }
}
</script>